export enum EnumHintKey {
  achAccountApprovalQuestion = 'ach_account_approval_question',
  fobHint = 'fob_hint',
  fcaHint = 'fca_hint',
  datHint = 'dat_hint',
  cptCfrHint = 'cpt_cfr_hint',
  incotermsHint = 'incoterms_hint',
  shippingDefinitionsHint = 'shipping_definitions_hint',
  eezyCustomsHint = 'eezy_customs_hint',
  internalNotesCardHint = 'internal_notes_card_hint',
  syncWithCbp = 'sync_with_cbp',
}
